import { DateTime } from "luxon";
import {
  BaseSupportContactResponse,
  BaseSupportContactRequest,
} from "@shared/types/common";

export default async (data?: object) => {
  const typedData = data as BaseSupportContactRequest;
  // In case of DELETE contact no data is provided, return an empty contact with default values
  return {
    First_Name__c: typedData ? typedData.first_name : "",
    Last_Name__c: typedData ? typedData.last_name : "",
    Email__c: typedData ? typedData.email : "",
    Time_zone: typedData ? typedData.time_zone : "",
    Role_Type__c: typedData ? typedData.role : "support",
    CreatedDate: DateTime.now().toISO(),
    Status__c: "In Progress",
  } satisfies BaseSupportContactResponse;
};
